import { render } from "./AddWorkHis.vue?vue&type=template&id=bdea2338"
import script from "./AddWorkHis.vue?vue&type=script&lang=js"
export * from "./AddWorkHis.vue?vue&type=script&lang=js"

import exportComponent from "I:\\JavaWork\\Recruit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__